import VueYandexMetrika from 'vue-yandex-metrika';
import * as Cookies from 'js-cookie';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';
import VueMeta from 'vue-meta';
import Router from 'vue-router';

import store from '../store/index';
import Auth from './auth';
import Franchaise from './franchaise';
import Pages from './pages';
import Partners from './partners';
import Players from './players';
import MozgoParty from './mozgo-party';
// import Home from '../views/Home.vue';


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...Auth,
    ...Pages,
    ...Franchaise,
    ...Partners,
    ...Players,
    ...MozgoParty,
  ],
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  const metaTags = document.querySelectorAll('[data-vue-router-controlled]');
  Array.from(metaTags)
    .map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) {
    return next();
  }

  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef)
      .forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    .forEach(tag => document.head.appendChild(tag));

  return next();
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth === undefined || record.meta.auth === null)) {
    next();
    return;
  }
  const fromCookie = Cookies.get('mozgoAuth');
  console.log(fromCookie, 'ROUTER')
  if (to.matched.some(record => record.meta.auth) && !store.getters.isAuthenticated && (!fromCookie && !fromCookie.length)) {
    next('/login');
    return;
  }

  if (to.matched.some(record => !record.meta.auth) && store.getters.isAuthenticated) {
    next('/partners');
    return;
  }

  next();
});


Vue.use(Router);
Vue.use(VueMeta);
Vue.use(VueYandexMetrika, {
  id: 53805307,
  router,
  env: process.env.NODE_ENV,
  debug: false,
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    ecommerce: 'dataLayer',
  },
});

Vue.use(VueGtm, {
  id: 'GTM-TMJJFW4',
  enabled: true,
  debug: true,
  vueRouter: router,
});

Vue.use(VueAnalytics, {
  id: 'UA-135634900-1',
  router,
});

export default router;
